import classNames from 'classnames';
import React from 'react';

import { NAVIGATION } from '../../../config';
import { KEYBOARD_EVENT_KEYS } from '../../../constants/keyboard-event-keys';
import { goToPath } from '../../../utils/navigation';
import { DropdownLayout } from '../../common';

import styles from './header-dropdown.scss';

interface Props {
  children: any;
  arrowClassName?: string;
  dropdownClass: string;
  options?: any;
  fixedHeader: any;
  fixedFooter?: any;
  maxHeightPixels: number;
  className?: string;
}

interface State {
  isOpen: boolean;
}

class HeaderDropdown extends React.Component<Props, State> {
  public state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  public componentDidMount() {
    // TODO: handle this on wix-style-react side
    document.addEventListener('keydown', this.onKeyDown.bind(this));
  }

  public componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown.bind(this));
  }

  private onKeyDown(event: KeyboardEvent) {
    if (event.key === KEYBOARD_EVENT_KEYS.ESCAPE) {
      this.setState({ isOpen: false });
    }
  }

  private onSelect(organization: any): void {
    goToPath(NAVIGATION.APPLICATION_STATE, {
      organizationId: organization.id,
    });

    this.close();
  }

  private close(): void {
    this.setState({
      isOpen: false,
    });
  }

  public render() {
    const {
      children,
      options,
      fixedHeader,
      fixedFooter,
      maxHeightPixels,
      dropdownClass,
      arrowClassName,
      className,
    } = this.props;

    return (
      <div className={classNames(styles.wrapper, className)}>
        <span
          className={styles.clickableArea}
          data-hook="header-dropdown-clickable-area"
          onClick={() => this.setState({ isOpen: !this.state.isOpen })}
        >
          {children}
        </span>

        {this.state.isOpen && (
          <div className={classNames(styles.dropdown, dropdownClass)}>
            <div className={classNames(styles.arrowUp, arrowClassName)} />

            <DropdownLayout
              visible
              options={options}
              fixedHeader={fixedHeader}
              fixedFooter={fixedFooter}
              maxHeightPixels={maxHeightPixels}
              onClickOutside={this.close.bind(this)}
              onSelect={this.onSelect.bind(this)}
            />
          </div>
        )}
      </div>
    );
  }
}

export default HeaderDropdown;
